import { DeleteOutlineRounded, EditOutlined, MoreVert } from '@mui/icons-material';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useCallback, useState } from 'react';

import { Question } from '../../../../Types/dealGPT';

interface QuestionContextMenuProps {
  question: Question;
  setShowDeleteConfirmation: (val: boolean) => void;
  setEditingQuestion: React.Dispatch<React.SetStateAction<Question | null>>;
}

const QuestionContextMenu: React.FC<QuestionContextMenuProps> = ({
  question,
  setShowDeleteConfirmation,
  setEditingQuestion,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }, []);

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ width: '40px', height: '40px' }}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setEditingQuestion(question);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Edit question" arrow>
              <EditOutlined fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Edit Question" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowDeleteConfirmation(true);
          }}
          sx={{ marginBottom: 1 }}
        >
          <ListItemIcon>
            <Tooltip title="Permanently delete this question" arrow>
              <DeleteOutlineRounded color="error" fontSize="small" />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Delete Question" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default QuestionContextMenu;
